import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

// import helper from 'helpers/steinerHelper';
import routeRegister from '../../../helpers/routeRegister';
// import { selectors } from '../reducers/statistiche';

const routes = {
    list: {
        list: {
            breadcrumb: 'Statistiche mail',
            componentPath: 'containers/StatisticheLayout',
            path: '/statistiche',
            exact: true
        }
    },
    patterns: {
        list: '/statistiche'
    }
};

const list = _.values(routes.list).map(route => ({
    ...route,
    hotelFilter: true,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'statistiche' */ `modules/statistiche/${
                route.componentPath
            }`).then(response => resolve(response.default));
        });
    }
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('statistiche', routes.patterns);
routeRegister.addLinks('statistiche', links);

export default list;
